import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {Observable} from 'rxjs';
import {ServiceWizardService} from '../../../../shared/state/service-wizard/service-wizard.service';
import {LoadingService} from '../../../../shared/state/loading/loading.service';
import {KeyboardQuery} from '../../../../shared/state/keyboard/keyboard.query';
import {ModalController} from '@ionic/angular';
import { ClinicDetailQuery } from 'src/app/shared/state/clinic-detail/clinic-detail.query';

@Component({
    standalone: false,
    selector: 'app-service-view',
    templateUrl: './service-view.component.html',
    styleUrls: ['./service-view.component.scss']
})
export class ServiceViewComponent implements OnInit {
    @ViewChild('dataContainer') dataContainer: ElementRef;
    @Input() serviceId: string;
    keyboardIsShowing: Observable<boolean>;

    /** Flowwwer template */
    clinicName$: Observable<string>;

    constructor(
        private serviceWizardService: ServiceWizardService,
        private loadingService: LoadingService,
        private keyboardQuery: KeyboardQuery,
        private modalController: ModalController,
        private clinicDetailQuery: ClinicDetailQuery
    ) {
    }

    async ngOnInit(): Promise<void> {
        this.keyboardIsShowing = this.keyboardQuery.select('isShowing');
        /** Flowwwer template */
        this.clinicName$ = this.clinicDetailQuery.select('commercialName');

        this.loadingService.updateShowSpinner(true);
        const productHtmlPage = await this.serviceWizardService.getServiceHtmlPage(this.serviceId);

        this.loadingService.updateShowSpinner(false);
        this.dataContainer.nativeElement.innerHTML = productHtmlPage;
        this.mountImageCarousel();
    }

    dismissModal() {
        this.modalController.dismiss();
    }

    /**
     * `productHtmlPage` embeds its own image gallery as a raw `<swiper-container>`
     * (Bootstrap/Swiper markup from the backend template) — swap it for the
     * design system's carousel/card instead of styling the injected one, and
     * drop the column entirely when there are no photos rather than leave an
     * empty gallery box. With a single photo the backend may render a bare
     * `<img>` in that same column instead of a `<swiper-container>`, so look
     * for images anywhere inside the gallery column rather than only inside it.
     */
    private mountImageCarousel(): void {
        const root: HTMLElement = this.dataContainer.nativeElement;
        const column = root.querySelector('.col-lg-6');
        if (!column) {
            return;
        }

        const images = Array.from(column.querySelectorAll('img'))
            .map(img => img.getAttribute('src'))
            .filter((src): src is string => !!src);

        if (images.length === 0) {
            column.remove();
            return;
        }

        if (images.length === 1) {
            const card = document.createElement('flw-image-card') as any;
            card.classList.add('service-gallery');
            card.href = images[0];
            card.src = images[0];
            card.alt = '';
            card.expandable = true;
            column.replaceWith(card);
            return;
        }

        const carousel = document.createElement('flw-carousel') as any;
        carousel.classList.add('service-gallery');
        carousel.align = 'flow';
        carousel.images = images;
        carousel.expandable = true;
        column.replaceWith(carousel);
    }
}
